<template>
    <purchase_order_detail v-if="userInfo.operation_mode == 3" :orderNumber="orderNumber"></purchase_order_detail>
    <order_detail v-else :orderNumber="orderNumber"></order_detail>
</template>

<script>
import order_detail from './order_detail.vue'
import purchase_order_detail from './purchase_order_detail.vue'
import {mapState} from "vuex";

export default {
    props: {
        orderNumber: String
    },

    computed: {
        ...mapState(['userInfo', 'systemConfig']),
    },

    components: {
        order_detail,purchase_order_detail
    }
}
</script>